export const RETROSPECTIVE_BLUEPRINT_COMPLETE_KEY =
	'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint';
